import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// --- Import redux
import { connect } from "react-redux";
// --- Import Compoennsts
import ProfileSelect from "../ProfileSelect/ProfileSelect";
// --- Import Images
import AccountIcon from "../../../assets/images/account_icon.png";
// --- Import Styles
import "./HeaderSelect.sass";

function HeaderSelect({ isAuth }) {
  return (
    <div className="account-btn-wrapper">
      {isAuth ? (
        <ProfileSelect />
      ) : (
        <Link to="/login" className="sign-in-btn">
          <span>Sign In</span>
          <img src={AccountIcon} alt="" />
        </Link>
      )}
    </div>
  );
}

HeaderSelect.propTypes = {
  isAuth: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuth: state.userDataStore.isAuth,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSelect);
